var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "animated fadeInDown"
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('auditReport.stockCorrection')))]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.stockcorrection('stockcorrectionform')
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('b-card', [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _vm._v(" "), _c('fieldset', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('auditReport.stockCorrectionType')) + " :")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "mb-3",
    class: {
      'form-control': true,
      'error': _vm.errors.has('stockupdate.correctiontype')
    },
    attrs: {
      "name": "correctiontype",
      "options": _vm.correctiontypes
    },
    on: {
      "input": _vm.checkcorrectiontype
    },
    model: {
      value: (_vm.stockupdate.correctiontype),
      callback: function($$v) {
        _vm.stockupdate.correctiontype = $$v
      },
      expression: "stockupdate.correctiontype"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('stockupdate.correctiontype')),
      expression: "errors.has('stockupdate.correctiontype')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('stockupdate.correctiontype')))]), _vm._v(" "), (_vm.stockupdate.correctiontype == '' || _vm.stockupdate.correctiontype == null) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.StockcorrErr))]) : _vm._e()], 1)]), _vm._v(" "), (_vm.stockupdate.correctiontype) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('auditReport.correctionReason')) + " :")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "mb-3",
    class: {
      'form-control': true,
      'error': _vm.errors.has('stockupdate.correctionreason')
    },
    attrs: {
      "options": _vm.correctionreasons
    },
    model: {
      value: (_vm.stockupdate.correctionreason),
      callback: function($$v) {
        _vm.stockupdate.correctionreason = $$v
      },
      expression: "stockupdate.correctionreason"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('stockupdate.correctionreason')),
      expression: "errors.has('stockupdate.correctionreason')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('stockupdate.correctionreason')))]), _vm._v(" "), (_vm.stockupdate.correctionreason == '' || _vm.stockupdate.correctionreason == null) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.CorrectionreasonErr))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  })]) : _vm._e(), _vm._v(" "), (_vm.stockupdate.correctiontype) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('inwardList.printData.comments')) + " :")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.stockupdate.comments),
      expression: "stockupdate.comments"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('stockupdate.comments')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('inwardList.inward.commentsPlaceholder'),
      "name": "comments",
      "id": "comments",
      "maxlength": "50",
      "data-vv-as": "comments",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.stockupdate.comments)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.stockupdate.comments = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  })]) : _vm._e(), _vm._v(" "), (_vm.stockupdate.correctiontype) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('common.rackID')) + " :")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-input', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('stockupdate.rackid')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('common.rackIDPlaceholder'),
      "name": "rackid",
      "id": "rackid",
      "data-vv-as": "Rack ID",
      "autocomplete": "off"
    },
    on: {
      "change": [_vm.checkrackid, _vm.getMerchantname]
    },
    model: {
      value: (_vm.stockupdate.rackid),
      callback: function($$v) {
        _vm.stockupdate.rackid = $$v
      },
      expression: "stockupdate.rackid"
    }
  }), _vm._v(" "), (_vm.isnotvalidrackid) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.invalidRackMessage))]) : _vm._e(), _vm._v(" "), (_vm.stockupdate.rackid == '') ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.RackErr))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [(_vm.isvalidrackid) ? _c('i', {
    staticClass: "fa fa-check",
    staticStyle: {
      "font-size": "25px",
      "color": "green"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isnotvalidrackid) ? _c('i', {
    staticClass: "fa fa-close",
    staticStyle: {
      "font-size": "25px",
      "color": "red"
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.isMultiseller) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.merchant')) + " "), _c('span', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v(_vm._s(_vm.isMultisellermessage))])])]) : _vm._e(), _vm._v(" "), (!_vm.isMultiseller) ? _c('div', {
    staticClass: "col-md-3"
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.stockupdate.correctiontype && _vm.isvalidrackid) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('common.productID')) + " :")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('stockupdate.productid')
    },
    attrs: {
      "data-vv-scope": "stockupdate",
      "type": "text",
      "placeholder": _vm.$t('common.productIDPlaceholder'),
      "name": "productid",
      "id": "productid",
      "data-vv-as": "Product ID / EAN Code",
      "autocomplete": "off"
    },
    on: {
      "change": _vm.checkproductid
    },
    model: {
      value: (_vm.stockupdate.productid),
      callback: function($$v) {
        _vm.stockupdate.productid = $$v
      },
      expression: "stockupdate.productid"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('stockupdate.productid')),
      expression: "errors.has('stockupdate.productid')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('stockupdate.productid')))]), _vm._v(" "), (_vm.isnotvalidproductid) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.producterrormsg))]) : _vm._e(), _vm._v(" "), (_vm.stockupdate.productid == '') ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.ProductErr))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [(_vm.isvalidproductid && _vm.stockupdate.productid != '') ? _c('i', {
    staticClass: "fa fa-check",
    staticStyle: {
      "font-size": "25px",
      "color": "green"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isnotvalidproductid) ? _c('i', {
    staticClass: "fa fa-close",
    staticStyle: {
      "font-size": "25px",
      "color": "red"
    }
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.stockupdate.correctiontype == 'issue' && _vm.isvalidrackid && _vm.isvalidproductid) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('inwardList.printData.productDetails.mrp')) + " :")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|decimal'),
      expression: "'required|decimal'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('stockupdate.mrp')
    },
    attrs: {
      "data-vv-scope": "stockupdate",
      "type": "text",
      "placeholder": _vm.$t('printProductDetails.mrpPH'),
      "name": "mrp",
      "id": "mrp",
      "data-vv-as": "MRP",
      "autocomplete": "off"
    },
    on: {
      "change": _vm.checkmrp
    },
    model: {
      value: (_vm.stockupdate.mrp),
      callback: function($$v) {
        _vm.stockupdate.mrp = $$v
      },
      expression: "stockupdate.mrp"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('stockupdate.mrp')),
      expression: "errors.has('stockupdate.mrp')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('stockupdate.mrp')))]), _vm._v(" "), (_vm.isnotvalidmrp) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('auditReport.mrpNotPresent')))]) : _vm._e(), _vm._v(" "), (_vm.rackisnotvalidmrp) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('auditReport.mrpAlreadyPresent')) + " .")]) : _vm._e(), _vm._v(" "), (_vm.mrp == '') ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.MRPErr))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [(_vm.isvalidmrp && _vm.stockupdate.mrp != '') ? _c('i', {
    staticClass: "fa fa-check",
    staticStyle: {
      "font-size": "25px",
      "color": "green"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isnotvalidmrp) ? _c('i', {
    staticClass: "fa fa-close",
    staticStyle: {
      "font-size": "25px",
      "color": "red"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.rackisnotvalidmrp) ? _c('i', {
    staticClass: "fa fa-close",
    staticStyle: {
      "font-size": "25px",
      "color": "red"
    }
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.stockupdate.correctiontype == 'receipt' && _vm.isvalidrackid && _vm.isvalidproductid) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('inwardList.printData.productDetails.mrp')) + " :")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('basic-select', {
    staticClass: "form-control",
    staticStyle: {
      "height": "32px",
      "padding": "8px",
      "padding-left": "13px",
      "border-radius": "0%"
    },
    attrs: {
      "options": _vm.mrpList,
      "placeholder": _vm.$t('grcList.SelectMrp'),
      "selected-option": _vm.selectedmrp
    },
    on: {
      "select": _vm.selectmrp
    },
    model: {
      value: (_vm.stockupdate.mrp),
      callback: function($$v) {
        _vm.stockupdate.mrp = $$v
      },
      expression: "stockupdate.mrp"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('stockupdate.mrp')),
      expression: "errors.has('stockupdate.mrp')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('stockupdate.mrp')))]), _vm._v(" "), (_vm.isnotvalidmrp) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('auditReport.mrpNotPresent')))]) : _vm._e(), _vm._v(" "), (_vm.rackisnotvalidmrp) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('auditReport.mrpAlreadyPresent')))]) : _vm._e(), _vm._v(" "), (_vm.mrp == '') ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.MRPErr))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [(_vm.isvalidmrp && _vm.stockupdate.mrp != undefined && _vm.stockupdate.mrp != null && _vm.stockupdate.mrp != '') ? _c('i', {
    staticClass: "fa fa-check",
    staticStyle: {
      "font-size": "25px",
      "color": "green"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isnotvalidmrp) ? _c('i', {
    staticClass: "fa fa-close",
    staticStyle: {
      "font-size": "25px",
      "color": "red"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.rackisnotvalidmrp) ? _c('i', {
    staticClass: "fa fa-close",
    staticStyle: {
      "font-size": "25px",
      "color": "red"
    }
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.stockupdate.correctiontype && _vm.isvalidrackid && _vm.isvalidproductid && _vm.isvalidmrp && _vm.islotcontrol == 1) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('grcLotReport.lotNumber')) + " :")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-input', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('stockupdate.lotnumber')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('grcLotReport.lotNumberPlaceHolder'),
      "id": "lotnumber",
      "data-vv-as": "lotnumber",
      "autocomplete": "off"
    },
    on: {
      "change": _vm.checklotnumber
    },
    model: {
      value: (_vm.stockupdate.lotnumber),
      callback: function($$v) {
        _vm.stockupdate.lotnumber = $$v
      },
      expression: "stockupdate.lotnumber"
    }
  }), _vm._v(" "), (_vm.stockupdate.lotnumber == '') ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('grcLotReport.lotNumberRequired')) + " ")]) : _vm._e(), _vm._v(" "), (_vm.isnotvalidlotnumber) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.loterrormsg))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [(_vm.isvalidlotnumber) ? _c('i', {
    staticClass: "fa fa-check",
    staticStyle: {
      "font-size": "25px",
      "color": "green"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isnotvalidlotnumber) ? _c('i', {
    staticClass: "fa fa-close",
    staticStyle: {
      "font-size": "25px",
      "color": "red"
    }
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.stockupdate.correctiontype && _vm.isvalidrackid && _vm.isvalidproductid && _vm.isvalidmrp) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('purchaseOrder.qty')) + " :")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|numeric'),
      expression: "'required|numeric'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('stockupdate.qty')
    },
    attrs: {
      "data-vv-scope": "stockupdate",
      "type": "number",
      "min": "1",
      "placeholder": _vm.$t('inwardList.printData.printBarcode.placeholder'),
      "name": "qty",
      "id": "qty",
      "onloadedmetadata": "",
      "data-vv-as": "Qty",
      "autocomplete": "off"
    },
    on: {
      "change": _vm.checkqty
    },
    model: {
      value: (_vm.stockupdate.qty),
      callback: function($$v) {
        _vm.stockupdate.qty = $$v
      },
      expression: "stockupdate.qty"
    }
  }), _vm._v(" "), (_vm.qtyerror) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.qtyerrormsg))]) : _vm._e(), _vm._v(" "), (_vm.qty == '') ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.QuantityrErr))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  })]) : _vm._e(), _vm._v(" "), (_vm.stockupdate.correctiontype && _vm.isvalidrackid && _vm.isvalidproductid && _vm.isvalidmrp && _vm.islotcontrol == 1 && _vm.isexpirycontrol == 1 && _vm.receipttype) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('grcList.mfgDate')) + " :")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('stockupdate.mfgdate')
    },
    attrs: {
      "data-vv-scope": "stockupdate",
      "type": "date",
      "placeholder": _vm.$t('auditReport.mfgDatePlaceHolder'),
      "name": "mfgdate",
      "id": "mfgdate",
      "onloadedmetadata": "",
      "data-vv-as": "MFG Date",
      "autocomplete": "off"
    },
    on: {
      "change": _vm.checkmfgdate
    },
    model: {
      value: (_vm.stockupdate.mfgdate),
      callback: function($$v) {
        _vm.stockupdate.mfgdate = $$v
      },
      expression: "stockupdate.mfgdate"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('stockupdate.mfgdate')),
      expression: "errors.has('stockupdate.mfgdate')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('stockupdate.mfgdate')))]), _vm._v(" "), (_vm.mfgerror) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.mfgerrormsg))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  })]) : _vm._e(), _vm._v(" "), (_vm.stockupdate.correctiontype && _vm.isvalidrackid && _vm.isvalidproductid && _vm.isvalidmrp && _vm.islotcontrol == 1 && _vm.isexpirycontrol == 1 && _vm.receipttype) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('auditReport.shelflife')) + " :")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('numeric'),
      expression: "'numeric'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('stockupdate.shelflife')
    },
    attrs: {
      "data-vv-scope": "stockupdate",
      "type": "text",
      "placeholder": _vm.$t('auditReport.shelflifePlaceHolder'),
      "name": "shelflife",
      "id": "shelflife",
      "onloadedmetadata": "",
      "data-vv-as": "shelflife",
      "autocomplete": "off"
    },
    on: {
      "change": _vm.checkshelflife
    },
    model: {
      value: (_vm.stockupdate.shelflife),
      callback: function($$v) {
        _vm.stockupdate.shelflife = $$v
      },
      expression: "stockupdate.shelflife"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('stockupdate.shelflife')),
      expression: "errors.has('stockupdate.shelflife')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('stockupdate.shelflife')))]), _vm._v(" "), (_vm.shelflifeerror) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.shelflifeerrormsg))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  })]) : _vm._e(), _vm._v(" "), (_vm.stockupdate.correctiontype && _vm.isvalidrackid && _vm.isvalidproductid && _vm.isvalidmrp && _vm.islotcontrol == 1 && _vm.isexpirycontrol == 1 && _vm.receipttype) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('printProductDetails.expiryDate')) + " :")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('stockupdate.expirydate')
    },
    attrs: {
      "data-vv-scope": "stockupdate",
      "type": "date",
      "placeholder": _vm.$t('printProductDetails.expiryDateError'),
      "name": "expirydate",
      "id": "expirydate",
      "onloadedmetadata": "",
      "data-vv-as": "Expiry Date",
      "autocomplete": "off"
    },
    on: {
      "change": _vm.checkexpirydate
    },
    model: {
      value: (_vm.stockupdate.expirydate),
      callback: function($$v) {
        _vm.stockupdate.expirydate = $$v
      },
      expression: "stockupdate.expirydate"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('stockupdate.expirydate')),
      expression: "errors.has('stockupdate.expirydate')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('stockupdate.expirydate')))]), _vm._v(" "), (_vm.expirydateerror) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.expirydateerrormsg))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "inwardfooter form-actions"
  }, [_c('b-button', {
    staticClass: "btn btn-success",
    attrs: {
      "disabled": _vm.isLoading,
      "type": "submit",
      "id": "save"
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" " + _vm._s(_vm.$t('common.saveBtn')) + "  ")])], 1)], 1)], 1)])])])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-f45fdb2a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f45fdb2a","hasScoped":true}!./src/views/components/stockCorrection/stockcorrection.component.html
// module id = 1562
// module chunks = 0